import { EventEmitter, Injectable, Output } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class LoadingService {
  public isShow = false;
  public progress = 0;

  constructor() {}

  public show(): void {
    setTimeout(() => (this.isShow = true));
  }

  public hide(): void {
    setTimeout(() => (this.isShow = false));
  }

  public setProgress(progress: number): void {
    this.progress = progress;
  }
}
